import { Observable } from 'rxjs';
import { Inject, Injectable } from '../../injection';
import { EmptyResponse } from '../data/empty-response.do';
import { OrganizationMembership } from '../data/organization-membership.do';
import { ApiEndpointConfiguration } from '../interfaces/api-endpoint-configuration.interface';
import { IMobizHttpService } from '../interfaces/mobiz-http.interface';
import { MobizServerApi } from '../other/mobiz-server-api.enum';
import { IMembershipService } from './membership.interface';

@Injectable()
export class MembershipService implements IMembershipService {
  constructor(
    @Inject(IMobizHttpService)
    private http: IMobizHttpService,
  ) {
  }

  /**
   * @inheritdoc
   */
  public delete(membershipId: any): Observable<EmptyResponse> {
    let config: ApiEndpointConfiguration = {
      serverApi: MobizServerApi.Membership,
      urlParameters: {
        membershipId: membershipId,
      },
    };

    return this.http.delete(new EmptyResponse(), config);
  }

  /**
   * @inheritdoc
   */
  public update(membership: OrganizationMembership): Observable<OrganizationMembership> {
    let config: ApiEndpointConfiguration = {
      serverApi: MobizServerApi.Membership,
      body: JSON.stringify(membership),
      urlParameters: {
        membershipId: membership.id,
      },
    };

    return this.http.put(new OrganizationMembership(), config);
  }
}
